<template lang="pug">
div
  Form(:data="control", :isSubmitting="isSubmitting", :isFromRisk="false", :isFromRiskEdit="false", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useControlAdd from './useControlAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, control, isSubmitting } = useControlAdd()

    return {
      control,
      create,
      isSubmitting,
    }
  },
}
</script>
